import { atom } from 'recoil';
import { Attachment } from '../interfaces/Attachment';

export interface AttachmentsListType {
  list: Attachment[] | null;
  percentDone: number | null;
}

export const AttachmentsListState = atom<AttachmentsListType>({
  key: 'AttachmentsListState',
  default: {
    list: null,
    percentDone: null,
  },
});
